import React from 'react';
import logo from './logo-enlong.png';

function AppLoadingScreen() {
    return (
        <div className="app-loading-screen">
            <div className="app-loading-screen__glow" />
            <div className="app-loading-screen__panel">
                <div className="app-loading-screen__logoWrap">
                    <img src={logo} className="app-loading-screen__logo" alt="Applicolis" />
                </div>
                <p className="app-loading-screen__eyebrow">Espace marchand</p>
                <h1 className="app-loading-screen__title">Initialisation de l'application</h1>
                <p className="app-loading-screen__subtitle">
                    Verification de la session en cours et chargement de vos donnees.
                </p>
                <div className="app-loading-screen__progress" aria-hidden="true">
                    <span className="app-loading-screen__progressBar" />
                </div>
            </div>
        </div>
    );
}

export default AppLoadingScreen;
